import { render, staticRenderFns } from "./GameMenu.vue?vue&type=template&id=c30fcda0&scoped=true&"
import script from "./GameMenu.vue?vue&type=script&lang=js&"
export * from "./GameMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameMenu.vue?vue&type=style&index=0&id=c30fcda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30fcda0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
